import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { GenericService } from 'src/app/services/generic.service';
import { IDropdownSettings } from 'ng-multiselect-dropdown';

import {
  CdkDragDrop,
  moveItemInArray,
  transferArrayItem,
} from '@angular/cdk/drag-drop';

@Component({
  selector: 'app-composition',
  templateUrl: './composition.component.html',
  styleUrls: ['./composition.component.css']
})
export class CompositionComponent implements OnInit {

  constructor(
    private fb: FormBuilder,
    private toastr: ToastrService,
    private generic_service: GenericService
  ) { }

  amount: number = 0;
  cProductList: any[] = [];
  filteredProductList: any[] = [];
  searchBoxTxt: string = '';
  
  cid: any;
  productName: string = '';
  batchPrice: number | null = null;
  batchQuantity: number | null = null;
  isDefault: any = '';
  done: any[] = [];

  uomDropdownList: any[] = [];
  uomSelectedList: any[] = [];
  uomDropdownSettings: IDropdownSettings = {
    singleSelection: false,
    idField: 'uomMasterId',
    textField: 'uomName',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 3,
    allowSearchFilter: true
  };

  ngOnInit(): void {
    this.cid = sessionStorage.getItem('cid');
    this.getAllUomMaster();
    this.getAllCProduct();
  }

  onItemSelect(item: any) { }

  onSelectAll(items: any) { }

  onSearchChange() {
    if (!this.searchBoxTxt) {
      this.filteredProductList = [...this.cProductList];
    } else {
      const lowerSearch = this.searchBoxTxt.toLowerCase();
      this.filteredProductList = this.cProductList.filter(p => p.name.toLowerCase().includes(lowerSearch));
    }
  }

  drop(event: CdkDragDrop<any[]>) {
    if (event.previousContainer === event.container) {
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    } else {
      const isMovingToDone = event.container.data === this.done;
      const movedItem = event.previousContainer.data[event.previousIndex];

      transferArrayItem(
        event.previousContainer.data,
        event.container.data,
        event.previousIndex,
        event.currentIndex,
      );

      if (isMovingToDone) {
        // Item moved from raw materials to done
        const indexInMaster = this.cProductList.findIndex(p => p.name === movedItem.name);
        if (indexInMaster > -1) {
          this.cProductList.splice(indexInMaster, 1);
        }
      } else {
        // Item moved from done back to raw materials
        movedItem.qty = 1;
        this.cProductList.push(movedItem);
        this.onSearchChange(); // Re-apply filter
      }
    }

    this.calculateTotalAmount();
  }

  addToDone(item: any, index: number) {
    this.done.push(item);
    this.filteredProductList.splice(index, 1);
    const masterIndex = this.cProductList.findIndex(p => p.name === item.name);
    if (masterIndex > -1) {
      this.cProductList.splice(masterIndex, 1);
    }
    this.calculateTotalAmount();
  }

  removeFromDone(index: number) {
    const item = this.done[index];
    item.qty = 1;
    this.done.splice(index, 1);
    this.cProductList.push(item);
    this.onSearchChange(); // Re-apply filter
    this.calculateTotalAmount();
  }

  amountChanged() {
    this.calculateTotalAmount();
  }

  calculateTotalAmount() {
    this.amount = 0;
    for (let i = 0; i < this.done.length; i++) {
      if (this.done[i].price != 0) {
        this.amount += Number(this.done[i].price) * Number(this.done[i].qty);
      }
    }
  }

  uomChange(event: any, index: number) {
    const selectedUomName = event.target.value;
    const supportedUOM = this.done[index].supportedUOM;
    
    for (let i = 0; i < supportedUOM.length; i++) {
      if (supportedUOM[i].uomName === selectedUomName) {
        this.done[index].price = supportedUOM[i].price;
        break;
      }
    }
    
    // Update amount whenever UOM changes since price might change
    this.calculateTotalAmount();
  }

  getAllUomMaster() {
    this.generic_service.getAllUomMaster().subscribe({
      next: (res: any) => {
        this.uomDropdownList = res.response;
      },
      error: (err: any) => {
        console.error(err);
      }
    });
  }

  getAllCProduct() {
    this.generic_service.getAllcProductMaster().subscribe({
      next: (response: any) => {
        this.cProductList = [];
        const resList = response.response || [];

        for (let i = 0; i < resList.length; i++) {
          let body = {
            name: String(resList[i].name),
            qty: 1,
            uom: '',
            price: 0,
            supportedUOM: resList[i].supportedUOM
          };

          if (resList[i].supportedUOM) {
            for (let j = 0; j < resList[i].supportedUOM.length; j++) {
              if (resList[i].supportedUOM[j].isDefault) {
                body.uom = resList[i].supportedUOM[j].uomName;
                body.price = resList[i].supportedUOM[j].price;
                break;
              }
            }
          }
          this.cProductList.push(body);
        }
        this.filteredProductList = [...this.cProductList];
      },
      error: (error: any) => {
        console.error(error);
      }
    });
  }

  add() {
    if (!this.productName) {
      this.toastr.error('Please enter formula name');
      return;
    }
    if (this.done.length === 0) {
      this.toastr.error('Please add at least one raw material to the composition');
      return;
    }
    if (this.uomSelectedList.length === 0) {
      this.toastr.error('Please select at least one UOM');
      return;
    }
    if (!this.isDefault) {
      this.toastr.error('Please select a default UOM');
      return;
    }

    let supportedUOMObjList: any[] = [];

    for (let j = 0; j < this.uomSelectedList.length; j++) {
      const selectedUomId = this.uomSelectedList[j].uomMasterId;
      const matchedDropdownItem = this.uomDropdownList.find(item => item.uomMasterId === selectedUomId);
      
      if (matchedDropdownItem) {
        supportedUOMObjList.push({
          uomId: matchedDropdownItem.uomMasterId,
          uomName: matchedDropdownItem.uomName,
          cid: matchedDropdownItem.cid,
          isDefault: (matchedDropdownItem.uomMasterId == this.isDefault)
        });
      }
    }

    // Clone done list to avoid modifying the UI bound data destructively if request fails
    const productCompositionIngList = this.done.map(item => {
      const { supportedUOM, ...rest } = item;
      return rest;
    });

    let body = {
      version: 0,
      isActive: true,
      description: '',
      productCompositionId: 0,
      productName: String(this.productName),
      batchPrice: Number(this.batchPrice || 0),
      batchQuantity: Number(this.batchQuantity || 0),
      totalAmount: this.amount, // Set totalAmount to actual calculated amount instead of 0
      supportedUOMObjList: supportedUOMObjList,
      productCompositionIngList: productCompositionIngList,
      cid: Number(this.cid)
    };

    this.generic_service.addProductComposition(body).subscribe({
      next: (response: any) => {
        this.getAllCProduct();
        this.productName = '';
        this.batchPrice = null;
        this.batchQuantity = null;
        this.isDefault = '';
        this.uomSelectedList = [];
        this.done = [];
        this.amount = 0;
        this.filteredProductList = [...this.cProductList];
        this.toastr.success(response.message || 'Added successfully');
      },
      error: (error: any) => {
        console.error(error);
        this.toastr.error('Failed to add product composition');
      }
    });
  }
}
